import { render, staticRenderFns } from "./SectionMain.vue?vue&type=template&id=49b9d65e&scoped=true&"
import script from "./SectionMain.vue?vue&type=script&lang=js&"
export * from "./SectionMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b9d65e",
  null
  
)

export default component.exports